import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { ConfigService } from "../config.service";
import { ProjectsService } from "../projects/projects.service";
import { ProgramsService } from "../programs/programs.service";
import { ApiService } from "../shared/api.service";

@Injectable()
export class BindingsService {
  public projects: any = [];
  public programs: any = [];
  private serviceUrl = ConfigService.serviceUrl;

  constructor(
    private http: Http,
    private programsService: ProgramsService,
    private projectService: ProjectsService
  ) {
    this.projectService.getProjects().subscribe((res) => {
      this.projects = res;
    });

    this.programsService.getPrograms().subscribe((res) => {
      this.programs = res;
    });
  }

  getBindings(options): Observable<any> {
    const { skip, limit } = this.generateOptions(options);
    return this.http
      .get(
        `${this.serviceUrl}/notifications/bindings?skip=${skip}&limit=${limit}`
      )
      .map((res) => {
        return this.extractData(res);
      })
      .catch(this.handleError);
  }

  generateOptions(options) {
    const { page, limit } = options;
    return {
      skip: page * limit,
      limit
    };
  }

  extractData = (res) => {
    if (res) {
      const body = res.json().reduce((prev, next) => {
        const {
          registration: { registration, binding }
        } = next;
        return [
          ...prev,
          { ...registration, binding, created_at: next.created_at }
        ];
      }, []);

      return body;
    } else {
      return [];
    }
  };

  getProjects(): Observable<any> {
    return this.projects;
  }

  getPrograms(): Observable<any> {
    return this.programs;
  }

  getCountryNames(ids: string[]): string[] {
    if (ids) {
      let names = ApiService.getCountryNames(ids);
      if (names.length > 0) {
        return names;
      }
    }
    return ["<any>"];
  }

  getLanguageNames(ids: string[]): string[] {
    if (ids) {
      let names = ApiService.getLanguageNames(ids);
      if (names.length > 0) {
        return names;
      }
    }
    return ["<any>"];
  }

  getItemsPerPage(): number {
    return ApiService.getItemsPerPage();
  }

  getItemsPerPageValues(): number[] {
    return ConfigService.itemsPerPageValues;
  }

  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || "";
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/bindings/bindings.service.ts